import { useEffect } from 'react';
import { Building } from 'lucide-react';
import { useCrmSellerStore } from '../../store/useCrmSellerStore';

/**
 * "Selling as" — the CRM session's company, shown in every CRM page header.
 *
 * One control, one store: changing it here changes it on Leads, Opportunities
 * and Quotes alike, so the person always knows whose deals they are looking at
 * and whose name a new quote will go out under.
 */
export default function SellingAs() {
  const { sellerOrgId, sellers, loadSellers, setSeller } = useCrmSellerStore();

  useEffect(() => { loadSellers(); }, [loadSellers]);

  return (
    <label
      className="flex items-center gap-1.5 text-xs text-gray-500 dark:text-gray-400"
      title="Which of our companies you are selling as. New opportunities and quotes are issued by it, and lists show its deals plus any with no seller set."
    >
      <Building size={13} className="text-accent shrink-0" />
      Selling as
      <select
        value={sellerOrgId}
        onChange={(e) => setSeller(e.target.value)}
        className="px-2 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-1 focus:ring-accent"
      >
        <option value="">All companies</option>
        {sellers.map((s) => (
          <option key={s._id} value={s.orgId}>{s.name}</option>
        ))}
      </select>
    </label>
  );
}
